import { render } from "./ApplicationsView.vue?vue&type=template&id=0fd4c317"
import script from "./ApplicationsView.vue?vue&type=script&lang=js"
export * from "./ApplicationsView.vue?vue&type=script&lang=js"

import "./ApplicationsView.vue?vue&type=style&index=0&id=0fd4c317&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__